import type { FC } from 'react';

import FormField from '@/common-components/FormField';
import Input from '@/common-components/Input';
import { useAcceptInvitePage } from '@/features/auth/hooks/useAcceptInvitePage.hook';

const AcceptInvitePage: FC = () => {
  const vm = useAcceptInvitePage();

  return (
    <div className="w-full max-w-md">
      <h1 className="text-[22px] font-extrabold text-[var(--color-ink)]">
        {vm.isDone ? "You're all set" : 'Set your password'}
      </h1>
      <p className="mt-1 text-[13px] text-[var(--color-ink-muted)]">
        {vm.isDone
          ? 'Your admin account is active. Sign in with your email and the password you just chose.'
          : 'Choose a password to activate your Shoutt admin account.'}
      </p>

      {vm.isDone ? (
        <button
          type="button"
          onClick={vm.onGoToLogin}
          className="mt-6 w-full rounded-lg bg-brand-500 px-4 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-brand-600"
        >
          Go to sign in
        </button>
      ) : !vm.hasToken ? (
        <p className="mt-6 rounded-lg bg-[var(--color-danger-bg)] px-3 py-2.5 text-[13px] font-semibold text-[var(--color-danger-ink)]">
          This link is missing its invitation code. Please open the link from your invitation email.
        </p>
      ) : (
        <div className="mt-6 flex flex-col gap-4">
          <FormField label="New password" htmlFor="invite-password" required error={vm.errors.password}>
            <Input
              id="invite-password"
              type="password"
              autoComplete="new-password"
              value={vm.form.password}
              onChange={(e) => vm.onChange('password', e.target.value)}
            />
          </FormField>

          <FormField label="Confirm password" htmlFor="invite-confirm" required error={vm.errors.confirm}>
            <Input
              id="invite-confirm"
              type="password"
              autoComplete="new-password"
              value={vm.form.confirm}
              onChange={(e) => vm.onChange('confirm', e.target.value)}
            />
          </FormField>

          <p className="text-[12px] text-[var(--color-ink-muted)]">
            At least 12 characters, with an uppercase letter, a lowercase letter and a number.
          </p>

          {vm.submitError ? (
            <p className="text-[13px] text-[var(--color-danger-ink)]">{vm.submitError}</p>
          ) : null}

          <button
            type="button"
            onClick={vm.onSubmit}
            disabled={vm.isSubmitting}
            className="w-full rounded-lg bg-brand-500 px-4 py-2.5 text-[13px] font-semibold text-white transition-colors hover:bg-brand-600 disabled:opacity-60"
          >
            {vm.isSubmitting ? 'Setting your password…' : 'Set password'}
          </button>
        </div>
      )}
    </div>
  );
};

export default AcceptInvitePage;
